// extracted by mini-css-extract-plugin
module.exports = {"breakpoint_xs":"30rem","breakpoint_sm":"48rem","breakpoint_md":"60rem","breakpoint_lg":"85rem","wrapper":"logo-module--wrapper--1qd0x","icon":"logo-module--icon--3Asmi"};